import { db } from "../../common/config/Firebase"
import { NO_CREATION } from "./config"

const invoicesCollection = db.collection('invoices')
const invoicesDetailCollection = db.collection('invoiceDetail')

const duplicateInvoiceUseCase = async (invoiceId, convertInInvoice = false) => {
    const invoice = await invoicesCollection.doc(invoiceId).get()
    const invoiceData = invoice.data()

    const invoiceDetail = await invoicesDetailCollection.doc(invoiceId).get()
    const invoiceDetailData = invoiceDetail.data()

    const rawDup = {
        ...invoiceData,
        isPrincipal: false,
        autogenerated: false,
        invoicePrincipalId: null,
        typeCreation: NO_CREATION,
        invoiceDate: new Date().getTime(),
        payed: 0,
        type: convertInInvoice ? 'Invoice' : (invoiceData.type || 'Invoice')
    }
    const cleanDup = Object.fromEntries(Object.entries(rawDup).filter(([, v]) => v !== undefined))
    const { id } = await invoicesCollection.add(cleanDup)

    // Solo copiamos el detalle si existe
    if (invoiceDetailData) {
        await invoicesDetailCollection.doc(id).set(invoiceDetailData)
    }
}

export default duplicateInvoiceUseCase